<template>
  <el-date-picker class="date-picker"
                  type="datetimerange" size="small" align="right"
                  range-separator="至" value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期" end-placeholder="结束日期"
                  :value="cValue" @input="handleInput" @change="emitChange"
                  :picker-options="pickerOptions"
  >
  </el-date-picker>
</template>

<script>
import {optionalValueMixin} from '../../../utils/optional-value'
export default {
  name: 'input-date-second',
  mixins: [optionalValueMixin],
  props: {
    pickerOptions: {}
  },
  data () {
    return {}
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/inputs/input-date-second.vue